import { SeatingTypes } from '../__generated/model/index.js'

export const SEATING_MAP = {
  [SeatingTypes.NoSeating]: {
    label: 'No Seating',
    value: SeatingTypes.NoSeating,
    purchasableAmounts: [0],
    pricing: {
      price: 0,
    },
  },
  [SeatingTypes.Benches]: {
    label: 'Benches',
    value: SeatingTypes.Benches,
    purchasableAmounts: [1, 2],
    pricing: {
      price: 955,
    },
  },
  [SeatingTypes.Chairs]: {
    label: 'Interested in Chairs',
    value: SeatingTypes.Chairs,
    purchasableAmounts: [0],
    pricing: {
      price: 0,
    },
  },
  [SeatingTypes.ChairsAndBenches]: {
    label: 'Interested in Combo',
    value: SeatingTypes.ChairsAndBenches,
    purchasableAmounts: [0],
    pricing: {
      price: 0,
    },
  },
}
